import { LanguageSwitch } from '@/components/LanguageSwitch/LanguageSwitch';
import { DateTimeWidget } from '@/components/DateTimeWidget/DateTimeWidget';
import type { LanguageCode } from '@/types';

interface HeaderProps {
  lang: LanguageCode;
  supported: LanguageCode[];
  onLangChange: (lang: LanguageCode) => void;
  /** Ha meg van adva, ez a logó jelenik meg a "VisitKiosk" felirat helyén (Site Settings). */
  logoUrl?: string | null;
}

export function Header({ lang, supported, onLangChange, logoUrl }: HeaderProps) {
  return (
    <header className="glass-header fixed top-2 inset-x-4 kiosk:top-[1.2vw] kiosk:inset-x-[3vw] z-40 grid grid-cols-3 items-center gap-2 px-3 py-2 kiosk:px-[3vw] kiosk:py-[2vw] rounded-2xl kiosk:rounded-[2vw] border border-kiosk-border shadow-lg shadow-black/10">
      <div className="justify-self-start">
        {logoUrl ? (
          <img src={logoUrl} alt="VisitKiosk" className="h-7 kiosk:h-[3vw] w-auto object-contain" />
        ) : (
          <div className="font-display text-base kiosk:text-kiosk-lg font-extrabold tracking-wide text-kiosk-accent truncate">
            VisitKiosk
          </div>
        )}
      </div>
      <div className="justify-self-center">
        <DateTimeWidget lang={lang} />
      </div>
      <div className="justify-self-end">
        <LanguageSwitch current={lang} supported={supported} onChange={onLangChange} />
      </div>
    </header>
  );
}
